/* AIOS-GIFTBOX-CART-GUARD (Alice 07/07/26)
   Two rules for the Deluxe Gift Box in the cart drawer + cart page:

   1) CAP — a customer can't have more gift boxes than jewellery pieces. Pressing the
      "+" on a gift box past that cap is blocked with a gentle toast. (boxes <= pieces)

   2) REMOVE-CONFIRM — when a jewellery piece is removed and it leaves an orphaned /
      linked gift box behind, a small popup asks "Remove its gift box packaging too?".
      Yes removes one box; No keeps it (customer's choice).

   Front-end only. Draft theme. Reversible. Identifies gift boxes by their 4 variant ids
   (the 4 gift-box sizes in GB_MAPPING, layout/theme.liquid). A "jewellery piece" = any
   cart line that is NOT one of those gift-box variants. */
(function () {
  if (window.__aiosGbGuard) return;
  window.__aiosGbGuard = true;

  // The 4 Deluxe Gift Box variants (Earring1GB / RingGB / NecklaceSetGB / LargeHoopGB).
  var GIFT_BOX_VARIANTS = [48189607149761, 48189918314689, 48189990109377, 48190013636801];
  function isBoxVariant(id) { return GIFT_BOX_VARIANTS.indexOf(parseInt(id, 10)) !== -1; }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ---- live counts from the cart DOM (synchronous, works for drawer + cart page) ----
  function inputVariantId(input) {
    return parseInt(input.getAttribute('data-quantity-variant-id') || (input.dataset && input.dataset.quantityVariantId) || '0', 10);
  }
  function domCounts(excludeInput) {
    var boxes = 0, jewel = 0, otherBoxes = 0;
    document.querySelectorAll('.cart-item').forEach(function (item) {
      var input = item.querySelector('.quantity__input, input[name="updates[]"]');
      if (!input) return;
      var vid = inputVariantId(input);
      var qty = parseInt(input.value || '0', 10) || 0;
      if (isBoxVariant(vid)) {
        boxes += qty;
        if (input !== excludeInput) otherBoxes += qty;
      } else {
        jewel += qty;
      }
    });
    return { boxes: boxes, jewel: jewel, otherBoxes: otherBoxes };
  }

  // ---- brand toast ----
  function toast(msg) {
    var t = document.getElementById('aios-gb-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'aios-gb-toast';
      t.style.cssText = 'position:fixed;left:50%;bottom:26px;transform:translateX(-50%);z-index:100000;' +
        'background:#2a2622;color:#fff;padding:12px 18px;font-size:0.9rem;max-width:88vw;text-align:center;' +
        'box-shadow:0 12px 30px rgba(0,0,0,.25);opacity:0;transition:opacity .2s;font-family:inherit;line-height:1.4;' +
        'display:flex;align-items:center;gap:10px';
      document.body.appendChild(t);
    }
    t.innerHTML = '<span style="color:#deb891;flex:0 0 auto">✦</span><span>' + escapeHtml(msg) + '</span>';
    t.style.opacity = '1';
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.style.opacity = '0'; }, 3200);
  }

  var CAP_MSG = 'One gift box per item — add another piece to include more.';

  // ---- RULE 1: block the gift-box "+" when it would exceed the jewellery count ----
  document.addEventListener('click', function (e) {
    var plus = e.target.closest && e.target.closest('.quantity__button[name="plus"]');
    if (!plus) return;
    if (!plus.closest('.cart-item')) return;            // only inside the cart
    var qi = plus.closest('quantity-input');
    var input = qi && qi.querySelector('input');
    if (!input || !isBoxVariant(inputVariantId(input))) return;   // only gift-box lines
    var c = domCounts();
    if (c.boxes + 1 > c.jewel) {
      e.preventDefault();
      e.stopImmediatePropagation();                     // stop Dawn's stepUp + cart change
      toast(CAP_MSG);
    }
  }, true); // capture — runs before Dawn's own button handler

  // ---- RULE 1b: stop a manually-typed gift-box quantity from going ABOVE the cap.
  //      Never forces a box DOWN — a box the customer already has (incl. an orphaned
  //      "empty box on its own") is always allowed to stay. Only blocks increases. ----
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('.quantity__input')) return;
    if (!input.closest('.cart-item')) return;
    if (!isBoxVariant(inputVariantId(input))) return;
    var want = parseInt(input.value || '0', 10) || 0;
    var prev = parseInt(input.getAttribute('value') || '0', 10) || 0;   // server-rendered value before this edit
    var c = domCounts(input);
    var allowed = Math.max(0, c.jewel - c.otherBoxes);  // room the pieces give this box line
    var ceiling = Math.max(allowed, prev);              // but never below what they already have
    if (want > ceiling) {
      e.preventDefault();
      e.stopImmediatePropagation();
      input.value = ceiling;
      toast(CAP_MSG);
    }
  }, true);

  // Header bag count lives on <a id="cart-icon-bubble">; the AJAX section file has no
  // that id, so we accept the section wrapper too.
  function applyBubbleHtml(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var src = doc.querySelector('#cart-icon-bubble') || doc.querySelector('#shopify-section-cart-icon-bubble') || doc.querySelector('.shopify-section');
    var tgt = document.querySelector('#cart-icon-bubble');
    if (src && tgt) tgt.innerHTML = src.innerHTML;
  }
  function refreshBubble() {
    fetch('/cart?section_id=cart-icon-bubble')
      .then(function (r) { return r.text(); })
      .then(applyBubbleHtml)
      .catch(function () {});
  }

  function normTitle(s) {
    return String(s || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }
  function titlesMatch(a, b) {
    a = normTitle(a); b = normTitle(b);
    if (!a || !b) return false;
    return a === b || a.indexOf(b) !== -1 || b.indexOf(a) !== -1;
  }

  // ---- RULE 2: offer to remove a linked gift box when a piece is removed ----
  var pendingRemoval = null;
  var dismissedKeys = {};
  var checking = false;
  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('cart-remove-button button, .cart-remove-button');
    if (!rm) return;
    var item = rm.closest('.cart-item');
    if (!item) return;
    var input = item.querySelector('.quantity__input, input[name="updates[]"]');
    var vid = input ? inputVariantId(input) : 0;
    if (isBoxVariant(vid)) return;                       // removing a box itself → no prompt
    var nameEl = item.querySelector('.cart-item__name');
    pendingRemoval = { title: nameEl ? nameEl.textContent.trim() : '', at: Date.now() };
    // don't block — let Dawn remove the piece, then react on cartUpdate.
    setTimeout(onCartChanged, 400);
    setTimeout(onCartChanged, 1600);
  }, true);

  function onCartChanged() {
    if (checking) return;
    checking = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        checking = false;
        refreshBubble();
        var boxes = cart.items.filter(function (it) { return isBoxVariant(it.id); });
        if (!boxes.length) { pendingRemoval = null; return; }
        var jewels = cart.items.filter(function (it) { return !isBoxVariant(it.id); });
        var jewelTitles = jewels.map(function (it) { return it.product_title || it.title || ''; });
        var removedTitle = pendingRemoval && (Date.now() - pendingRemoval.at) < 12000 ? pendingRemoval.title : '';

        var target = null;
        boxes.forEach(function (it) {
          if (target || dismissedKeys[it.key]) return;
          var p = it.properties && (it.properties['Gift wrap for'] || it.properties['gift wrap for'] || '');
          if (!p) return;
          var stillThere = jewelTitles.some(function (t) { return titlesMatch(t, p); });
          if (!stillThere) target = it;
        });
        if (!target && removedTitle) {
          target = boxes.filter(function (it) {
            var p = it.properties && (it.properties['Gift wrap for'] || it.properties['gift wrap for'] || '');
            return titlesMatch(removedTitle, p) && !dismissedKeys[it.key];
          })[0] || null;
        }
        if (!target) {
          var jewelUnits = jewels.reduce(function (n, it) { return n + it.quantity; }, 0);
          var boxUnits = boxes.reduce(function (n, it) { return n + it.quantity; }, 0);
          if (boxUnits > jewelUnits) {
            target = boxes.filter(function (it) { return !dismissedKeys[it.key]; })[0] || null;
          }
        }
        if (target) {
          pendingRemoval = null;
          showRemoveBoxConfirm(removedTitle || (target.properties && target.properties['Gift wrap for']) || '', target);
        }
      })
      .catch(function () { checking = false; });
  }

  function showRemoveBoxConfirm(itemTitle, boxItem) {
    if (document.getElementById('aios-gb-confirm-overlay')) return;
    var shortTitle = itemTitle && itemTitle.length > 60 ? itemTitle.slice(0, 58) + '…' : itemTitle;
    var wrap = document.createElement('div');
    wrap.id = 'aios-gb-confirm-overlay';
    wrap.style.cssText = 'position:fixed;inset:0;background:rgba(40,36,32,.55);z-index:100001;display:flex;' +
      'align-items:center;justify-content:center;padding:16px';
    var m = document.createElement('div');
    m.setAttribute('role', 'dialog');
    m.setAttribute('aria-modal', 'true');
    m.style.cssText = 'background:#fff;max-width:392px;width:100%;padding:24px 20px 20px;text-align:center;' +
      'box-shadow:0 40px 80px rgba(0,0,0,.3);font-family:inherit';
    m.innerHTML =
      '<h2 style="font-family:\'Cormorant Garamond\',Garamond,\'Times New Roman\',serif;font-weight:500;' +
        'font-size:1.85rem;line-height:1.1;margin:0 0 10px;color:#2a2622">Remove the gift box too?</h2>' +
      '<p style="font-size:0.93rem;color:#6b655d;margin:0 0 20px;line-height:1.55">You removed ' +
        (shortTitle ? '<strong>' + escapeHtml(shortTitle) + '</strong>' : 'that item') +
        '. Would you like to remove its Deluxe Gift Box packaging as well?</p>' +
      '<button id="aios-gb-confirm-yes" style="display:block;width:100%;background:#111;color:#fff;border:none;' +
        'padding:15px 20px;font-size:0.9rem;font-weight:600;letter-spacing:.06em;text-transform:uppercase;' +
        'cursor:pointer;margin-bottom:8px">Yes, remove the gift box</button>' +
      '<button id="aios-gb-confirm-no" style="display:block;width:100%;background:none;border:none;color:#8a8378;' +
        'font-size:0.86rem;letter-spacing:.02em;cursor:pointer;padding:8px;font-family:inherit">No, keep it</button>';
    wrap.appendChild(m);
    document.body.appendChild(wrap);
    function close() { if (wrap.parentNode) wrap.parentNode.removeChild(wrap); }
    m.querySelector('#aios-gb-confirm-no').addEventListener('click', function () {
      if (boxItem && boxItem.key) dismissedKeys[boxItem.key] = 1;
      close();
    });
    wrap.addEventListener('click', function (ev) {
      if (ev.target === wrap) {
        if (boxItem && boxItem.key) dismissedKeys[boxItem.key] = 1;
        close();
      }
    });
    m.querySelector('#aios-gb-confirm-yes').addEventListener('click', function () {
      var yes = m.querySelector('#aios-gb-confirm-yes');
      yes.textContent = 'Removing…';
      yes.disabled = true;
      removeBoxLine(boxItem, close);
    });
  }

  function removeBoxLine(boxItem, done) {
    // Preferred path: click the gift box's OWN remove button in the drawer — this reuses
    // Dawn's proven removal (429-retry fetch + section re-render), so the box actually
    // leaves the cart AND the drawer repaints. Match the exact box line by its
    // "Gift wrap for" note when there is more than one box.
    var wrapFor = boxItem.properties && (boxItem.properties['Gift wrap for'] || boxItem.properties['Gift wrap for ']);
    var matched = null, firstBox = null;
    document.querySelectorAll('.cart-item').forEach(function (item) {
      var input = item.querySelector('.quantity__input, input[name="updates[]"]');
      if (!input || !isBoxVariant(inputVariantId(input))) return;
      if (!firstBox) firstBox = item;
      if (wrapFor && !matched && item.textContent.indexOf(wrapFor) !== -1) matched = item;
    });
    var line = matched || firstBox;
    var btn = line && line.querySelector('cart-remove-button button, cart-remove-button');
    if (btn) {
      btn.click();                 // fires Dawn's own removal path
      if (done) done();
      return;
    }
    // Fallback: direct AJAX by line key if the DOM button can't be found.
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: boxItem.key,
        quantity: Math.max(0, (boxItem.quantity || 1) - 1),
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: '/cart'
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) { refreshDrawer(res); if (done) done(); })
      .catch(function () { if (done) done(); });
  }

  function refreshDrawer(res) {
    if (res && res.sections) {
      var dp = new DOMParser();
      if (res.sections['cart-drawer']) {
        var nd = dp.parseFromString(res.sections['cart-drawer'], 'text/html').querySelector('#CartDrawer');
        var cd = document.querySelector('#CartDrawer');
        if (nd && cd) cd.innerHTML = nd.innerHTML;
      }
      if (res.sections['cart-icon-bubble']) applyBubbleHtml(res.sections['cart-icon-bubble']);
      else refreshBubble();
    }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && res && res.item_count === 0) drawer.classList.add('is-empty');
    // keep the rest of the theme (free-ship bar, upsells) in sync.
    // NOTE: PUB_SUB_EVENTS is a top-level `const` (assets/constants.js) — a bare global,
    // NOT window.PUB_SUB_EVENTS. Reference it bare with a typeof guard (same pattern the
    // theme itself uses at layout/theme.liquid:3719).
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'aios-gb-guard', cartData: res });
      }
    } catch (e) {}
  }

  // Subscribe to the theme's cart-update event. `subscribe`/`PUB_SUB_EVENTS` are bare
  // globals (constants.js / pubsub.js), reachable by identifier, not off `window`.
  function wire() {
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, onCartChanged);
        return true;
      }
    } catch (e) {}
    return false;
  }
  function initWire() {
    if (wire()) return;
    var tries = 0;                          // pub/sub not ready yet — retry briefly
    var iv = setInterval(function () {
      if (wire() || ++tries > 40) clearInterval(iv);
    }, 150);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWire);
  } else {
    initWire();
  }
})();
